import { Component, Inject  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppState } from '@app/state/app.state';
import { Store } from '@ngrx/store';
import { SetQuoteDueDate } from '@quoting/state/actions/quoting-module.actions';

@Component({
  selector: 'app-confirm-due-date',
  templateUrl: './confirm-due-date.component.html',
  styleUrls: ['./confirm-due-date.component.scss']
})
export class ConfirmDueDateComponent {
  

  constructor(
    public dialogRef: MatDialogRef<ConfirmDueDateComponent>, 
    private store: Store<AppState>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }



  public quoteDueDate: string;
    
  public setQuoteDueDate(): void {    
    let quoteDueDate = null;
    if (this.quoteDueDate != null && typeof this.quoteDueDate != 'undefined') {
      let datePartArr = this.quoteDueDate.split("-");
      quoteDueDate = new Date(Date.UTC(Number(datePartArr[0]), Number(datePartArr[1]), Number(datePartArr[2]), 23, 59, 59));
    } else {
      let dateToUse = new Date();
      quoteDueDate = new Date(Date.UTC(dateToUse.getFullYear(), dateToUse.getMonth(), dateToUse.getDate(), 23, 59, 59));
    }
    this.store.dispatch(new SetQuoteDueDate(quoteDueDate));
  }

}
